// extracted by mini-css-extract-plugin
export default {"review_block":"GoogleReviews_review_block__CXU88","stars":"GoogleReviews_stars__LM6g3"};